import React from 'react'

const Stereo = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M62.996 377.146c-18.221 0-33.045-14.824-33.045-33.046V167.045c0-18.221 14.824-33.045 33.045-33.045h385.958C467.176 134 482 148.824 482 167.045V344.1c0 18.222-14.824 33.046-33.046 33.046H62.996z"
    />
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={399.299} cy={223.229} r={32.938} />
    <circle fill="none" stroke={color} strokeWidth={20} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} cx={399.299} cy={308.209} r={19.791} />
    <path
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M320 315.712v-65.131c0-6.289-5.145-11.434-11.434-11.434H99.434c-6.289 0-11.434 5.145-11.434 11.434v65.131c0 6.289 5.145 11.434 11.434 11.434h209.131c6.29 0 11.435-5.145 11.435-11.434zM120.506 280.426h31.538M256.515 280.426h31.538M189.496 291.559h31.538M88 191.146h232"
    />
  </svg>
)
export default Stereo
